/**
 * Query string para endpoints Index paginados (F4-011).
 */
export function buildPagedQuery({ page = 1, pageSize = 10, sort, direction, search, filters = {} }) {
  const params = new URLSearchParams();
  params.set('page', String(page));
  params.set('pageSize', String(pageSize));
  if (sort) {
    params.set('sort', sort);
  }
  if (direction) {
    params.set('direction', direction);
  }
  if (search) {
    params.set('search', search);
  }
  Object.entries(filters).forEach(([key, value]) => {
    if (value != null && value !== '') {
      params.set(`filter.${key}`, String(value));
    }
  });
  return params.toString();
}

export function normalizePageAfterQueryChange() {
  return 1;
}

export function normalizePageAfterPageSizeChange() {
  return 1;
}

export function resolvePageAfterDelete({ currentPage, totalPages, itemsOnCurrentPage }) {
  if (itemsOnCurrentPage > 1 || currentPage < totalPages) {
    return currentPage;
  }
  return Math.max(1, currentPage - 1);
}

export function clampPage({ page, totalCount, pageSize }) {
  const size = pageSize > 0 ? pageSize : 10;
  const maxPage = Math.max(1, Math.ceil(totalCount / size));
  if (page > maxPage) {
    return 1;
  }
  return Math.max(1, page);
}

export function computePageCount(totalCount, pageSize) {
  const size = pageSize > 0 ? pageSize : 10;
  return Math.max(1, Math.ceil(totalCount / size));
}
